import React, { useContext, useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { AppContent, AppSidebar, AppFooter, AppHeader } from '../components/index';
import { UserContext } from '../Contexts/UserContext';
import FooterForm from '../views/dashboard/NewComponents/FooterForm';
import BroadcastMessage from '../components/shared/BroadCast/BroadCastMessage';
import { DASHBOARD_URL, BROADCAST_MSG_FETCH, BASIC_TOKEN_HEADER } from '../constants/api.config';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import axios from 'axios';
import useBreakpoints from 'src/utils/Breakpoints';
import { getUserToken, globalLogoutFunction } from 'src/utils/handleCookie';
import { notify } from 'src/utils/notifyFunction';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { broadCastMessageHandler } from 'src/utils/handleCookie';




const DefaultLayout = ({ loadingFlag }) => {
  const { contextUserData, setContextUserData } = useContext(UserContext);
  const { isLg } = useBreakpoints();
  const [allowedRoutes, setAllowedRoutes] = useState([]);
  const [footerFormOpen, setFooterFormOpen] = useState(false);
  const [sideBarFlag, setSideBarFlag] = useState(() => {
    if (!isLg) return false;
    const savedState = sessionStorage.getItem('sideBarOpen');
    return savedState ? JSON.parse(savedState) : false;
  });

  const [expandedMenu, setExpandedMenu] = useState(() => {
    const savedExpanded = sessionStorage.getItem('expandedSubmenu');
    return savedExpanded ? JSON.parse(savedExpanded) : null;
  });

  const [currentMessage, setCurrentMessage] = useState([]);
  const location = useLocation();
  const history = useHistory();
  const updateSideBarFlag = (newState) => {
    setSideBarFlag(newState);
    sessionStorage.setItem('sideBarOpen', JSON.stringify(newState));
  };

  const updateExpandedMenu = (menuId) => {
    setExpandedMenu(menuId);
    sessionStorage.setItem('expandedSubmenu', JSON.stringify(menuId));
  };
  useEffect(() => {
    const savedState = sessionStorage.getItem('sideBarOpen');
    if (savedState) {
      setSideBarFlag(JSON.parse(savedState));
    }
  }, [location.pathname]);


  useEffect(() => {
    if (contextUserData?.AllowedRoutes?.length > 0) {
      const tempAllowedRoutes = [...contextUserData?.AllowedRoutes];
      const otherAllowedRoutes = ["/homeBuilding", '/home/ALL', '/watchlist', "/testroute", "/home/Map/:activetab/:menuid", "/reportscreenmenu"];
      const newAllowedRoutesArray = tempAllowedRoutes.concat(otherAllowedRoutes);
      setAllowedRoutes(newAllowedRoutesArray);
    }
  }, [contextUserData?.AllowedRoutes]);

  const handleFooterFormOpen = () => setFooterFormOpen(true);
  const handleFooterFormClose = () => setFooterFormOpen(false);
  const handleBroadCastClose = () => setContextUserData((prev) => ({ ...prev, showBrodCastMessage: false }));

  async function broadcastMessageFettcher() {


    const tempcurrentMessage = await broadCastMessageHandler()
    if (tempcurrentMessage) {
      if (tempcurrentMessage === "LOGOUT") {
        history.push("/login")
      }
      else if (tempcurrentMessage !== "LOGOUT") {
        setCurrentMessage(tempcurrentMessage)
      }
    }

  }

  useEffect(() => {

    broadcastMessageFettcher();

  }, [location.pathname]);

  const drawerWidth = sideBarFlag ? 270 : 76;
  const contentShift = isLg ? drawerWidth : 0;

  return (
    <Box sx={{
      display: 'flex',
      minHeight: '100vh',
      background: '#f8fafc',
    }}>
      <AppSidebar
        sideBarFlag={sideBarFlag}
        setSideBarFlag={updateSideBarFlag}
        expandedMenu={expandedMenu}
        setExpandedMenu={updateExpandedMenu}
        handleFooterFormOpen={handleFooterFormOpen}
      />

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        zIndex: 1,
        // width: isLg ? `calc(100% - ${contentShift}px)` : '100%',
        width: isLg ? '100%' : '100%',
      }}>
        <AppHeader
          sideBarFlag={sideBarFlag}
          setSideBarFlag={updateSideBarFlag}
          currentMessage={currentMessage}
        />

        <Box sx={{
          flexGrow: 1,
          p: 2.5,
          background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
          transition: 'padding 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}>
          <FooterForm
            open={footerFormOpen}
            onClose={handleFooterFormClose}
          />

          <BroadcastMessage
            handleBroadCastClose={handleBroadCastClose}
            open={contextUserData?.showBrodCastMessage}
            broadcastMessageFettcher={broadcastMessageFettcher}
            currentMessage={currentMessage}
          />

          <AppContent
            loadingFlag={loadingFlag}
            AllowedRoutes={allowedRoutes}
            currentMessage={currentMessage}
            sideBarFlag={sideBarFlag}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DefaultLayout;